import { TimeOfDayOption } from 'us-web-services';

export enum GeneralTime {
  early = 'timeEarly',
  morning = 'timeMorning',
  afternoon = 'timeAfternoon',
  evening = 'timeEvening',
  overnight = 'timeOvernight',
  never = 'timeNever',
}

export const timesOfDay: TimeOfDayOption[] = [
  {
    code: '',
    id: -1,
    label: 'Please select an option',
  },
  {
    code: 'specific',
    id: 1,
    label: 'Specify times',
  },
  {
    code: 'day',
    id: 2,
    label: 'During the day',
  },
  {
    code: 'night',
    id: 3,
    label: 'During the night',
  },
];
